

export const columns = [
    { id: "Sl #", label: "Sl #", minWidth: 30,align:"center" },
    { id: "HiringCompany", label: "Hiring Company", minWidth: 190,align:"left" },
    { id: "website", label: "Company Website", minWidth: 350,align:"left" },
    { id: "processName", label: "Process Name", minWidth: 190,align:"left" },
    { id: "baseUrl", label: "Base URL", minWidth: 210,align:"left" },
    { id: "Action", label: "Action", minWidth: 120,align:"left" },
  ];